export let MainForm = {
    ramo: 0,
    modalidad: '',
    modules: null

}
